import bookingService from '../../services/bookingService';

const state = {
  bookings: [],
  roomBookings: [],
  courseReservations: []
};

const getters = {
  allBookings: state => state.bookings,
  allRoomBookings: state => state.roomBookings,
  allCourseReservations: state => state.courseReservations
};

const actions = {
  async fetchBookings({ commit }, filters = {}) {
    try {
      console.log('Fetching bookings with filters:', filters);
      const response = await bookingService.getBookings(filters);
      console.log('Store received response:', response);
      commit('setBookings', response.data);
    } catch (error) {
      console.error('Store error:', error);
      commit('setBookings', []);
    }
  },

  async addBooking({ commit }, bookingData) {
    const response = await bookingService.addBooking(bookingData);
    commit('newBooking', response.data);
  },

  async updateBooking({ commit }, bookingData) {
    const { id, ...data } = bookingData;
    const response = await bookingService.updateBooking(id, data);
    commit('updateBooking', response.data);
  },

  async deleteBooking({ commit }, bookingId) {
    await bookingService.deleteBooking(bookingId);
    commit('removeBooking', bookingId);
  },

  async fetchRoomBookings({ commit }) {
    try {
      const response = await bookingService.fetchRoomBookings();
      if (response.data.success) {
        commit('SET_ROOM_BOOKINGS', response.data);
      }
      return response;
    } catch (error) {
      console.error('Error in fetchRoomBookings action:', error);
      throw error;
    }
  },
  
  async fetchRoomBookingsWithDetails({ commit }) {
    try {
      const response = await bookingService.fetchRoomBookingsWithDetails();
      if (response.data.success) {
        commit('SET_ROOM_BOOKINGS', response.data);
      }
      return response;
    } catch (error) {
      console.error('Error in fetchRoomBookingsWithDetails action:', error);
      throw error;
    }
  },
  
  async fetchCourseReservations({ commit }) {
    try {
      const response = await bookingService.fetchCourseReservations();
      if (response.data.success) {
        commit('SET_COURSE_RESERVATIONS', response.data.data);
      }
      return response;
    } catch (error) {
      console.error('Error in fetchCourseReservations action:', error);
      throw error;
    }
  }
};

const mutations = {
  setBookings: (state, bookings) => {
    state.bookings = bookings || [];
  },
  newBooking: (state, bookingData) => state.bookings.push(bookingData),
  updateBooking: (state, updatedBooking) => {
    const index = state.bookings.findIndex(booking => booking.id === updatedBooking.id);
    if (index !== -1) {
      state.bookings.splice(index, 1, updatedBooking);
    }
  },
  removeBooking: (state, bookingId) => {
    state.bookings = state.bookings.filter(booking => booking.id !== bookingId);
  },
  SET_ROOM_BOOKINGS(state, bookings) {
    state.roomBookings = bookings;
  },
  SET_COURSE_RESERVATIONS(state, reservations) {
    state.courseReservations = reservations;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 